<template>
  <div
    class="mode-card"
    :class="{ selected: isSelected }"
    @click="$emit('select')"
  >
    <div class="mode-icon">
      <i :class="mode.icon"></i>
    </div>
    <div class="mode-title">{{ mode.title }}</div>
    <div class="mode-subtitle">{{ mode.subtitle }}</div>
  </div>
</template>

<script>
export default {
  name: "ModeCard",
  props: {
    mode: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["select"],
};
</script>

<style scoped>
.mode-card {
  background-color: var(--card-bg);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-lg);
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform var(--transition-normal),
    box-shadow var(--transition-normal);
  cursor: pointer;
  text-align: center;
  box-shadow: var(--shadow-sm);
}

.mode-card:hover,
.mode-card.selected {
  transform: translateY(-5px);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--accent-color);
}

.mode-card.selected {
  background-color: rgba(0, 224, 208, 0.1);
}

.mode-icon {
  font-size: 2.5rem;
  color: var(--accent-color);
  margin-bottom: var(--spacing-md);
}

.mode-title {
  font-weight: 600;
  font-size: var(--font-size-md);
  margin-bottom: var(--spacing-xs);
}

.mode-subtitle {
  font-size: var(--font-size-xs);
  color: #8a8a8a;
}
</style>
